var DEFAULT_MAX_ELEMENT_SIZE = 33554432;
var FIREFOX_MAX_ELEMENT_SIZE = 8947850;

var isBrowser = function isBrowser() {
    return typeof window !== 'undefined';
};

var isFirefox = function isFirefox() {
    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
};

export var getMaxElementSize = function getMaxElementSize() {
    if (isBrowser()) {
        if (isFirefox()) {
            return FIREFOX_MAX_ELEMENT_SIZE;
        }
    }
    return DEFAULT_MAX_ELEMENT_SIZE;
};
